// PROSPECT on-site AI-discoverability checker — self-contained vanilla JS.
// Injects its own styles + an inline section, and calls the /api/audit Netlify
// function (netlify/functions/audit.mjs). NO tokens: the audit is pure
// fetch+parse+score on the server. Bundled into the site by Parcel via the
// <script> tag in index.html.

(function () {
  'use strict';

  var API_URL = '/api/audit';

  var ja = document.documentElement.lang
    ? document.documentElement.lang.toLowerCase().indexOf('ja') === 0
    : (navigator.language || 'ja').toLowerCase().indexOf('ja') === 0;

  var T = ja
    ? {
        heading: 'あなたのサイトは、AIに見つけてもらえますか？',
        sub: 'URLを入力すると、ChatGPT・Claude・Perplexity などのAIがあなたのサイトをどれだけ「見つけ・理解・推薦」できるかを無料で診断します（数十秒）。',
        placeholder: 'https://あなたのサイト.jp',
        button: '無料で診断する',
        checking: '診断中…',
        scoreLabel: 'AI発見性スコア',
        gapsLabel: '検出した主な改善点',
        fixLine:
          'これらは人には見えにくいものの、AIが貴社を推薦する妨げになります。Webサイトの再構築で解消できます。',
        cta: '無料で詳細診断・ご相談',
        unreachable:
          'サイトを取得できませんでした。URLをご確認ください（公開サイトのみ対応）。',
        error: '診断に失敗しました。時間をおいて再度お試しください。',
        outOf: '/ 100',
      }
    : {
        heading: 'Can AI find your website?',
        sub: 'Enter your URL for a free check of how well AI assistants (ChatGPT, Claude, Perplexity…) can find, read and recommend your site. Takes a few seconds.',
        placeholder: 'https://your-site.com',
        button: 'Run free check',
        checking: 'Checking…',
        scoreLabel: 'AI-discoverability score',
        gapsLabel: 'Top things to fix',
        fixLine:
          "These are hard for a human to spot but hold back how AI recommends you — a website rebuild fixes them.",
        cta: 'Get a free detailed audit',
        unreachable:
          'Could not fetch that site. Please check the URL (public sites only).',
        error: 'The check failed. Please try again in a moment.',
        outOf: '/ 100',
      };

  function injectStyles() {
    var css =
      '.pa-section{padding:60px 20px;background:linear-gradient(to top left,#eafaf1,#f7fdf9);font-family:"Poppins",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}' +
      '.pa-wrap{max-width:760px;margin:0 auto;text-align:center}' +
      '.pa-h{font-size:26px;font-weight:600;color:#1a1a1a;margin:0 0 10px}' +
      '.pa-sub{font-size:15px;line-height:1.7;color:#4a4a4a;margin:0 0 24px}' +
      '.pa-form{display:flex;gap:10px;justify-content:center;flex-wrap:wrap}' +
      '.pa-input{flex:1;min-width:240px;max-width:440px;padding:13px 15px;font-size:15px;font-family:inherit;border:1px solid #cfe6d8;border-radius:10px;outline:none}' +
      '.pa-input:focus{border-color:#39b385;box-shadow:0 0 0 3px rgba(57,179,133,.15)}' +
      '.pa-btn{padding:13px 22px;font-size:15px;font-weight:600;font-family:inherit;color:#fff;background:#0a7d4d;border:none;border-radius:10px;cursor:pointer;transition:transform .12s ease,background .2s}' +
      '.pa-btn:hover{background:#0b8f58;transform:translateY(-1px)}' +
      '.pa-btn:disabled{opacity:.6;cursor:default;transform:none}' +
      '.pa-result{margin-top:26px;background:#fff;border:1px solid #e5efe9;border-radius:14px;box-shadow:0 6px 26px rgba(0,0,0,.06);padding:24px;text-align:left;display:none}' +
      '.pa-result.pa-show{display:block}' +
      '.pa-scorebar{display:flex;align-items:center;gap:18px;flex-wrap:wrap}' +
      '.pa-ring{width:96px;height:96px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-direction:column;flex:none;color:#fff;font-weight:700}' +
      '.pa-ring b{font-size:30px;line-height:1}' +
      '.pa-ring span{font-size:11px;font-weight:500;opacity:.9}' +
      '.pa-scoremeta{flex:1;min-width:200px}' +
      '.pa-scoremeta h4{margin:0 0 4px;font-size:14px;color:#6b7280;font-weight:500}' +
      '.pa-scoremeta .pa-url{font-size:15px;color:#111;font-weight:600;word-break:break-all}' +
      '.pa-gaps{margin:20px 0 0;padding:0;list-style:none}' +
      '.pa-gaps li{position:relative;padding:8px 0 8px 26px;font-size:14px;line-height:1.6;color:#333;border-top:1px solid #f0f4f2}' +
      '.pa-gaps li:before{content:"!";position:absolute;left:0;top:8px;width:18px;height:18px;border-radius:50%;background:#fff3d6;color:#b8860b;font-size:12px;font-weight:700;text-align:center;line-height:18px}' +
      '.pa-gapslabel{font-size:13px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-top:20px}' +
      '.pa-fix{margin:18px 0 16px;font-size:14px;line-height:1.7;color:#374151}' +
      '.pa-cta{display:inline-block;padding:12px 22px;font-size:15px;font-weight:600;color:#fff;background:linear-gradient(to top left,#39b385,#0a7d4d);border:none;border-radius:10px;cursor:pointer;text-decoration:none}' +
      '.pa-msg{font-size:14px;color:#b91c1c;margin-top:14px}';
    var el = document.createElement('style');
    el.textContent = css;
    document.head.appendChild(el);
  }

  function scoreColor(s) {
    if (s >= 70) return '#2f9e6f';
    if (s >= 40) return '#d9a300';
    return '#e0575f';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function render() {
    var section = el('section', 'pa-section');
    section.id = 'ai-audit';
    var wrap = el('div', 'pa-wrap');

    wrap.appendChild(el('h2', 'pa-h', T.heading));
    wrap.appendChild(el('p', 'pa-sub', T.sub));

    var form = el('form', 'pa-form');
    var input = el('input', 'pa-input');
    input.type = 'text';
    input.placeholder = T.placeholder;
    input.setAttribute('aria-label', T.placeholder);
    var btn = el('button', 'pa-btn', T.button);
    btn.type = 'submit';
    form.appendChild(input);
    form.appendChild(btn);
    wrap.appendChild(form);

    var result = el('div', 'pa-result');
    wrap.appendChild(result);
    section.appendChild(wrap);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      run(input.value.trim(), btn, result);
    });

    return section;
  }

  function run(url, btn, result) {
    if (!url) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = T.checking;
    result.className = 'pa-result';
    result.innerHTML = '';

    fetch(API_URL, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ url: url }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { status: r.status, data: d };
        });
      })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = original;
        if (res.status !== 200 || res.data.error) {
          showMsg(result, res.data.error || T.error);
          return;
        }
        if (!res.data.reachable) {
          showMsg(result, T.unreachable);
          return;
        }
        showResult(result, res.data);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        showMsg(result, T.error);
      });
  }

  function showMsg(result, msg) {
    result.innerHTML = '';
    result.appendChild(el('p', 'pa-msg', msg));
    result.className = 'pa-result pa-show';
  }

  function showResult(result, data) {
    result.innerHTML = '';
    var s = data.scoreOutOf100;

    var bar = el('div', 'pa-scorebar');
    var ring = el('div', 'pa-ring');
    ring.style.background = scoreColor(s);
    var num = el('b', null, String(s));
    ring.appendChild(num);
    ring.appendChild(el('span', null, T.outOf));
    bar.appendChild(ring);

    var meta = el('div', 'pa-scoremeta');
    meta.appendChild(el('h4', null, T.scoreLabel));
    meta.appendChild(el('div', 'pa-url', data.url));
    bar.appendChild(meta);
    result.appendChild(bar);

    var gaps = (data.topGaps || []).slice(0, 4);
    if (gaps.length) {
      result.appendChild(el('div', 'pa-gapslabel', T.gapsLabel));
      var ul = el('ul', 'pa-gaps');
      gaps.forEach(function (g) {
        ul.appendChild(el('li', null, ja ? g.textJa || g.text : g.text));
      });
      result.appendChild(ul);
    }

    result.appendChild(el('p', 'pa-fix', T.fixLine));

    var cta = el('a', 'pa-cta', T.cta);
    cta.href = '#contact';
    result.appendChild(cta);

    result.className = 'pa-result pa-show';
  }

  function mount() {
    injectStyles();
    var section = render();
    // Place the checker right before the contact section so the CTA flows
    // straight into the form; fall back to end of <body>.
    var contact =
      document.getElementById('contact') ||
      document.querySelector('.contact-form');
    if (contact) {
      var host = contact.closest('section') || contact;
      host.parentNode.insertBefore(section, host);
    } else {
      document.body.appendChild(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
